import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    baseUrl: string;
    constructor() {
        this.baseUrl = window['ApiUrl'];
    }
}
